import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { SITE } from "@/constants/testIds";
import logoImg from "@/assets/moduleris-logo.jpeg";

const links = [
  { id: SITE.navHome, label: "Anasayfa", href: "#top" },
  { id: SITE.navAbout, label: "Kurumsal", href: "#about" },
  { id: SITE.navServices, label: "Hizmetlerimiz", href: "#services" },
  { id: SITE.navProjects, label: "Projelerimiz", href: "#projects" },
  { id: "nav-link-gallery", label: "Galeri", href: "#gallery" },
  { id: SITE.navContact, label: "İletişim", href: "#contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-black/70 border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid={SITE.logo}
          className="flex items-center gap-3 group"
          aria-label="MoDuLerİS Anasayfa"
        >
          <span className="relative inline-flex items-center justify-center w-10 h-10 md:w-11 md:h-11 bg-white/95 p-1 shadow-[0_0_0_1px_rgba(255,255,255,0.08)]">
            <img
              src={logoImg}
              alt="MoDuLerİS logo"
              className="w-full h-full object-contain"
            />
          </span>
          <span className="font-display font-semibold text-base md:text-lg tracking-tight">
            MoDuLer<span className="text-[#ff5a00]">İ</span>S
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.id}
              data-testid={l.id}
              href={l.href}
              className="nav-link text-[13px] uppercase tracking-[0.18em] text-neutral-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <a
            data-testid={SITE.ctaHeader}
            href="#contact"
            className="btn-accent inline-flex items-center px-5 py-3 text-[12px] uppercase tracking-[0.2em] font-semibold"
          >
            Teklif Al
          </a>
        </div>

        <button
          data-testid={SITE.mobileMenuToggle}
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-neutral-200 p-2 -mr-2"
          aria-label="Menüyü aç/kapat"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid={SITE.mobileMenu}
          className="md:hidden border-t border-white/10 bg-black/95 backdrop-blur-xl"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.id}
                data-testid={`m-${l.id}`}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-neutral-200 text-sm uppercase tracking-[0.18em]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="btn-accent inline-flex items-center justify-center px-5 py-3 text-[12px] uppercase tracking-[0.2em] font-semibold"
            >
              Teklif Al
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
